import {
  GET_DX_APP_SETTINGS,
  GET_DX_APP_SETTINGS_FULFILLED,
  GET_DX_APP_SETTINGS_FAILURE,
  GET_DX_APP_SETTINGS_PENDING,
} from './discovery-xcipio-actions';
import { DiscoveryXcipioState } from './discovery-xcipio.types';

const MB = 1048576;

const defaultState: DiscoveryXcipioState = {
  // Warrant_bSelectAllHI3Interfaces - if true, select ALL HI3 interfaces in the Case
  // panel by default, otherwise select the first HI3 Interface.
  discoveryXcipioSettings: {
    Warrant_bSelectAllHI3Interfaces: true,
    // Attachment_Size_Limit - the maximum attachment size that can be uploaded. unit is in bytes
    Attachment_Size_Limit: 10 * MB,
    // Warrant_bAttachments_enabled - if true, attachment feature is enabled.
    Warrant_bAttachments_enabled: false,
    /**  Set to true enable Multirow selection for warrant grid    */
    isBulkActionsEnabled: false,
    isAdditionalWarrantStateEnabled: false,
    Warrant_bArchiveWarrant: false,
    isAuditEnabled: true,
    isExternalDashboardEnabled: false,
    isSecurityGatewayEnabled: false,
    isNetworkTopologyEnabled: true,
    // xcEwarrantEnable - if true, the eWarrant feature (eWarrants tab and CSP settings) is enabled.
    xcEwarrantEnable: false,
    isAlarmFeatureEnabled: false,
    isAlarmNotificationProfileEnabled: true,
    shouldUseNetworkTopologyMockData: undefined,
    isXmsMenusEnabled: true,
    externalDashboardIP: '',
    logiOAuthClientId: '',
    logiOAuthClientSecret: '',
    logiOAuthClientName: '',
    logiAdminAccount: '',
    logiAdminUserName: '',
    logiAdminPswd: '',
    logiSupervisorUserName: '',
    logiSupervisorPswd: '',
    language: '',
    // indicate the user deployment.  At this time, it can be V or Endeavor
    deployment: 'andromeda',
    networkTopologyPollingTime: '',
    logiRefreshTimeInSec: 60,
    'networkTopology.defaultHome': '38,-98.5795',
    'backupservice.url': '',
    sslCertDir: '',
    xccaCaNamePrefix: '',
    afsExportLimit: 10000,
    cfsExportLimit: 2000,
    isT1678HITlsEnabled: false,
    is33108HITlsEnabled: false,
    isIdentifierAssociationExtensionsEnabled: false
  },
};

const moduleReducer = (state = defaultState, action: any): DiscoveryXcipioState => {
  switch (action.type) {
    case GET_DX_APP_SETTINGS_PENDING:
        return {
          ...state,
          isLoadingAppSettings: true,
        }
    case GET_DX_APP_SETTINGS_FAILURE:
      return {
        ...state,
        isLoadingAppSettings: false,
        isAppSettingLoaded: true,
      }
    case GET_DX_APP_SETTINGS_FULFILLED:
      if (!action.payload.data.data || action.payload.data.data.length < 1) {
        return {
          ...state,
          isLoadingAppSettings: false,
          isAppSettingLoaded: true,
        };
      }
      const newDiscoveryXcipioSettings: any = {};

      if (action.payload.data.data[0].appSettings) {
        action.payload.data.data[0].appSettings.forEach((dxSetting: any) => {
          if (newDiscoveryXcipioSettings[dxSetting.name] === undefined) {
            if (dxSetting.type === 'boolean') {
              newDiscoveryXcipioSettings[dxSetting.name] = (dxSetting.setting === 'true');
            } else { // default is text
              newDiscoveryXcipioSettings[dxSetting.name] = dxSetting.setting;
            }
          }
        });
      }
      // TODO: Remove "isAuditEnabled" bit implementation from the code. User Audit is always enabled.
      // For now hardcoding it to true to ignore the server value.
      newDiscoveryXcipioSettings.isAuditEnabled = true;

      return {
        ...state,
        discoveryXcipioSettings: {
          ...state.discoveryXcipioSettings,
          ...{
            ...newDiscoveryXcipioSettings,
            Attachment_Size_Limit: parseInt(newDiscoveryXcipioSettings.Attachment_Size_Limit ?? '0', 10) || 10 * MB,
            Attachment_Files_Limit: parseInt(newDiscoveryXcipioSettings.Attachment_Files_Limit ?? '0', 10) || 20,
          },
        },
        isLoadingAppSettings: false,
        isAppSettingLoaded: true,
      };
    default:
      return state;
  }
};
export default moduleReducer;
